export default __webpack_public_path__ + "static/media/Loading.f82d41d2.gif";